import { render, staticRenderFns } from "./SalPrereceiptList.vue?vue&type=template&id=a98519b0&scoped=true&"
import script from "./SalPrereceiptList.vue?vue&type=script&lang=js&"
export * from "./SalPrereceiptList.vue?vue&type=script&lang=js&"
import style0 from "./SalPrereceiptList.vue?vue&type=style&index=0&id=a98519b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98519b0",
  null
  
)

export default component.exports